<template>
  <div class="special-page">
    <AgileWrap :photos="gallery" />
  </div>
</template>

<script>
import AgileWrap from "@/components/AgileWrap.vue"
import { apiBaseUrl } from "@/config/api"

export default {
  name: "Gallery",
  data() {
    return {
      gallery: [],
    }
  },
  created() {
    fetch(apiBaseUrl + "gallery")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json() // or .text(), .blob(), etc.
      })
      .then((data) => {
        console.log(data)
        this.gallery = data
      })
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    showArrows() {
      return this.cursorArrowCoords.x > 0 && this.cursorArrowCoords.y > 0
    },
  },
  methods: {},
  components: {
    AgileWrap,
  },
}
</script>
